import { logger } from "@swa-ui/log";

import { resolveBaseUrl } from "../buildIframeSrc";

/**
 * Single source of truth for "is this PPA hotel iframe config usable to render the iframe".
 * Consumed by `PPAHotelContainer` (to gate iframe render) and `PPAHotelWidget` (to gate the
 * loading skeleton). Add new required-field checks here when the vendor contract grows so
 * all call sites pick them up.
 *
 * Also verifies the resolved `baseUrl` is a parseable URL. Without this check, a garbage
 * string in bootstrap (`iframeUrl.staging: "not a url"`) would pass the presence check but
 * fail silently at runtime: `getOrigin` returns `null`, every incoming postMessage fails
 * origin validation, and the widget hangs on the loading skeleton with no way to recover.
 */
export const isHotelIFrameDataValid = (hotelIFrameData) => {
  const baseUrl = resolveBaseUrl(hotelIFrameData);
  const hasRequiredFields = Boolean(baseUrl) && Boolean(hotelIFrameData?.cid);
  let hasParseableUrl = false;

  if (hasRequiredFields) {
    try {
      const parsedUrl = new URL(baseUrl);

      hasParseableUrl = typeof parsedUrl.origin === "string";
    } catch (error) {
      logger.error("PPAHotelContainer: could not parse iframe base URL from bootstrap", {
        baseUrl,
        component: "isHotelIFrameDataValid",
        error,
      });
    }
  }

  return hasParseableUrl;
};
